import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { AnimatedTextView } from '../Typography/AnimatedTextView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { Shadow } from '../../Styles/Shadow';
import { getColorScheme } from '../../Hooks/UseColorScheme';
export const CardView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.card,
    style(theme, mediaQuery, window, props) {
        return {
            container: Object.assign(Object.assign({ borderRadius: 8 }, Shadow.level(typeof props.shadowLevel === 'number'
                ? props.shadowLevel
                : 1)), { backgroundColor: getColorScheme().value.colors.background }),
            body: {
                paddingHorizontal: 20,
                paddingVertical: 22
            },
            header: {
                flexDirection: 'row',
                paddingHorizontal: 20,
                paddingVertical: 17,
                borderBottomColor: '#DBE2EB',
                borderBottomWidth: 1,
            },
            title: {
                fontSize: 14,
                lineHeight: 18,
                fontWeight: 'bold',
                textTransform: 'uppercase'
            }
        };
    }
})(({ style, containerStyles, header, title, titleStyles, bodyStyles, children, footer }) => {
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyles], children: [!!header && header(), !!title && (_jsx(View, { style: [style === null || style === void 0 ? void 0 : style.header, titleStyles], children: _jsx(AnimatedTextView, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: title }) })), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.body, bodyStyles], children: children }), !!footer && footer()] }));
});
